import * as React from 'react';
import EmailInput from './EmailInput';
import LinkButton from './LinkButton';
import '../css/addPayment.sass';
import PaymentIcon from './PaymentIcon';

export interface BTADetails {
  emailAddress?: string;
  accountNumber?: string;
}

export interface BTAState {
  emailAddress?: string;
  isValid?: boolean;
}

interface BTAProps {
  billToAccountLabel?: string;
  ebillLabel?: string;
  accountNumber?: string;
  emailAddress?: string;
  eBillEnrolled?: boolean;
  eBillEnrolledMsg?: React.ReactNode;
  eBillEnrollingMsg?: React.ReactNode;
  emailUpdateMsg?: React.ReactNode;
  confirmEmailLink?: string;
  emailLabel?: string;
  displayDetails?: boolean;
  iconAltText?: string;
  onAddBTA: (details: BTADetails) => void;
}

export default function BillToAccount(props: BTAProps) {
  const {
    displayDetails = false,
    billToAccountLabel = 'Bill to Account',
    ebillLabel = 'eBill Required',
    confirmEmailLink = 'Confirm Email',
    emailLabel = 'Email Address',
    iconAltText = 'Dish beacon logo',
    eBillEnrolled = false,
    eBillEnrolledMsg = "You've already signed up for eBill, let's just confirm that we're sending them to the right email.",
    eBillEnrollingMsg = 'You must opt in to receive your bill via email before we can apply the payment extension to your account.',
    emailUpdateMsg = 'Updating your email address will also update it for all other email communications from DISH.'
  } = props;
  const [state, setState] = React.useState<BTAState>({
    emailAddress: props.emailAddress,
    isValid: false
  });

  const accountNumberFormatted =
    props.accountNumber &&
    props.accountNumber
      .trim()
      .replace(/(.{4})/g, '$1 ')
      .trim();

  return (
    <div className="addPayment">
      {displayDetails && (
        <>
          <div>{billToAccountLabel}</div>
          <div className="endingWith">
            <PaymentIcon
              className="brandImg"
              brandName={iconAltText}
              brand="BILLTOACCOUNT"
            />
            {accountNumberFormatted && (
              <span className="cardDetails"> {accountNumberFormatted}</span>
            )}
          </div>
          <div className="hr">&nbsp;</div>
        </>
      )}
      <span className="eBillHeading">{ebillLabel}</span>
      <div className="eBillRequired">
        {eBillEnrolled ? eBillEnrolledMsg : eBillEnrollingMsg}
      </div>
      <EmailInput
        required
        name="email"
        id="email"
        label={emailLabel}
        hasError={false}
        value={state.emailAddress}
        onComplete={(emailAddress: string) =>
          setState({
            ...state,
            emailAddress,
            isValid: true
          })
        }
        onError={() =>
          setState({
            ...state,
            isValid: false
          })
        }
      />
      <span className="eMailInfo">{emailUpdateMsg}</span>
      <div style={{ textAlign: 'right' }}>
        <LinkButton
          name="addBTA"
          id="addBTA"
          smol
          disabled={!state.isValid}
          onClick={() => {
            props.onAddBTA({
              emailAddress: state.emailAddress,
              accountNumber: accountNumberFormatted
            });
          }}
        >
          {confirmEmailLink}
        </LinkButton>
      </div>
    </div>
  );
}
